import { CardType } from 'Prototype/Level/Card/CardType';
import { PlaySound } from 'System/Audio/AudioHelper';
import { CardModifierType } from 'Prototype/Level/Card/CardModifierType';
import { CardTask } from '../Card/CardTasks';
import Environment from 'Utility/Environment';
import { ICardStateData, ICardStateTaskData } from '../Card/ICardState';
import { report, ReportTags } from 'report';

export default class AudioStateHelper {
    /**
     * Check if the card can be played and emit a sound
     * accordantly with the card type
     */
    public static cardPlayed(card: ICardStateData) {
        // go through each modifier and emit a sound
        card.modifiers.forEach(modifier => {
            switch (modifier.type) {
                case CardModifierType.pickaxe:
                    AudioStateHelper.play('pickaxe');
                    break;

                case CardModifierType.rising: {
                    AudioStateHelper.play('hot');
                    break;
                }

                case CardModifierType.lowering: {
                    AudioStateHelper.play('cold');
                    break;
                }

                default:
                    debugReport('Missing sound for given CardModifierType', {
                        cardModifierType: modifier.type,
                    });
            }
        });

        // check card type and emit a sound
        switch (card.type) {
            case CardType.zap:
                AudioStateHelper.play('scythe');
                break;

            case CardType.boom:
                AudioStateHelper.play('beehive');
                break;

            case CardType.plus_three:
                AudioStateHelper.play('harvest-festival');
                break;

            default:
                debugReport('Missing sound for given CardType', {
                    cardType: card.type,
                });
        }
    }

    /**
     * Emits a sound for each unique task in the state
     */
    public static cardTask = (tasks: ReadonlyArray<ICardStateTaskData>) => {
        tasks.forEach(({ task }, index, tasks) => {
            // Check if this sound was already handled
            const firstIndexOfThisTask = tasks.findIndex(e => e.task === task);
            if (firstIndexOfThisTask < index) return;

            switch (task) {
                case CardTask.ROCK:
                    AudioStateHelper.play('stone');
                    break;

                case CardTask.BOMB: {
                    AudioStateHelper.play('tomato');
                    break;
                }

                case CardTask.KEY: {
                    AudioStateHelper.play('lock-and-key');
                    break;
                }

                case CardTask.UNDO_MATCH: {
                    AudioStateHelper.play('undo');
                    break;
                }

                case CardTask.REVEAL_JOKER_PRE_BOOSTER: {
                    AudioStateHelper.play('extra_wildcards_appear');
                    break;
                }

                case CardTask.RECEIVE_JOKER_PRE_BOOSTER: {
                    AudioStateHelper.play('extra_wildcards_collect');
                    break;
                }

                case CardTask.REVEAL_CANISTER_PRE_BOOSTER: {
                    AudioStateHelper.play('canister_card_appear');
                    break;
                }

                case CardTask.USE_CANISTER_PRE_BOOSTER: {
                    AudioStateHelper.play(/*Tyrion*/ 'canister');
                    break;
                }

                default:
                    debugReport('Missing sound for given CardTask', { task });
            }
        });
    };

    // TODO: Remove sound effect triggers from state flow - should happen in store listeners.
    private static play(
        id: string
    ) {
        PlaySound(id);
    }
}

function debugReport(
    message: string,
    tags: ReportTags
) {
    if (process.env.NODE_ENV !== Environment.DEVELOPMENT) return;
    report(message, {
        once: true,
        // Only log, don't actually report
        sampleRate: 0,
        tags,
    });
}
